import React from 'react';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import s from './ReactionButton.scss';
var ReactionButton = function (_a) {
    var iconUrl = _a.iconUrl, text = _a.text, onClick = _a.onClick;
    return (React.createElement(PlainButtonOrLink, { className: s['root'], onClick: onClick },
        React.createElement("div", { className: s['icon'] },
            React.createElement("img", { src: iconUrl, alt: text })),
        React.createElement("div", { className: s['text'] }, text)));
};
ReactionButton.displayName = 'ReactionButton';
export default ReactionButton;
//# sourceMappingURL=ReactionButton.js.map